import React from 'react';
import ReactDOMClient from 'react-dom/client';
import { App } from '~/components/root/App';
import './index.css';
import 'react-loading-skeleton/dist/skeleton.css';
import * as Sentry from '@sentry/react';

if (process.env.NODE_ENV !== 'development') {
  Sentry.init({
    dsn: 'https://050b6df58ced6a324d5740d8e6b9da85@o4508820028719104.ingest.us.sentry.io/4508820033634304',
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
      /^https:\/\/conversations-tbitio\.koyeb\.app\.io\/api/,
      /^https:\/\/conversations\.t-bit\.io\/api/,
    ],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}

const container = document.getElementById('root') as HTMLElement;

// @ts-ignore
window.global = window;
const root = ReactDOMClient.createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
